export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
        initialFilters: {
            type: Object,
            required: true,
        },
        gridTitle: {
            type: String,
            required: true,
        },
        initialSort: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            hiddenColumns: ['id'],
            filtersOptions: {},
            downloadingFile: false,
        };
    },
    computed: {
        tab() {
            return this.$store.state.spire.tab;
        },
        previewModal: {
            get() {
                return this.$store.state.spire.previewModal;
            },
            set(modal) {
                return this.$store.dispatch('spire/setPreviewModal', modal);
            },
        },
    },
    mounted() {
        this.$store.dispatch('spire/searchPatient', {
            name: null,
        });
    },
    methods: {
        async exportRecordAsPdf(item) {
            if (this.downloadingFile) {
                return;
            }

            this.downloadingFile = true;

            return await axios
                .get(route('spire-blood-results.export-record-as-pdf', { spire_blood_result: item.id }))
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = response.request.responseURL;
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                })
                .finally(() => {
                    _.delay(() => {
                        this.downloadingFile = false;
                    }, 2000);
                });
        },
        onCloseDateFilter(filters, filter) {
            switch (filter) {
                case 'filter_date_taken':
                    filters.filters.date_taken = null;
                    filters.filters.filter_date_taken = null;
                    break;
                default:
                    break;
            }
        },
        patientItemUrl(patient) {
            return route('patients.get', { id: patient.id });
        },
        deleteItemUrl(item) {
            return route('api.v1.spire-blood-results.destroy', { spire_blood_result: item.id });
        },
        triggerDeleted() {
            this.datatableKey++;
            this.$root.notify('info', t('default::notification.success'), t('spire-ftp::notification.deleted'));
        },
        async viewFile(item) {
            return await this.$store
                .dispatch('spire/fetchCurrentSample', item)
                .then(() => {
                    this.previewModal = true;
                })
                .catch((error) => {
                    return this.$root.notify('error', error.response.data.error);
                });
        },
        viewSample(item) {
            if (!item.blood_result_id && !item.patient) return;
            return this.$root.goTo(
                route('patients.get', {
                    patient: item.patient.id,
                    load_lood_result: true,
                    blood_result_id: item.blood_result_id,
                })
            );
        },
    },
};
